module.exports = __webpack_public_path__ + "confirmation-tooth.png?1b91928401686654312411d001fa8219";


//////////////////
// WEBPACK FOOTER
// ./images/confirmation-tooth.png
// module id = 165
// module chunks = 0